<template>
    <header class="root-header-bar" v-if="$isRootRoute()">
        <div v-if="headerTitle === ''" class="front-bi"><img class="main-img" :src="require('@/assets/images/front_bi.png')" height="28px"/></div>
        <div v-else-if="headerTitle === '약속 관리' || headerTitle === '마이페이지'" class="nav-title">{{ headerTitle }}</div>
        <div v-else class="left">{{ headerTitle }}</div>

        <div v-if="headerTitle === '약속 관리' || headerTitle === '마이페이지'" class="left"><i @click="clickToChatroom" class="back-button material-icons">{{ 'chevron_left' }} </i> </div>
        <div class="right">
            <!-- <img
                @click="onClickHowToUsePoint"
                class="m-r-2"
                src="@/assets/images/point.png"
                width="24px"
                height="24px"
            /> -->
            <!-- <div class="invitation-point p-relative" v-html="badges.invite_point" /> -->
            <div class="bell p-relative" @click="onClickNotification">
                <img class="m-r-2" src="@/assets/images/alarm.png" width="20px" height="20px" />
                <!-- <i class="material-icons">notifications_none</i> -->
                <div v-if="showUnreadNotifications" class="badge" />
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: 'RootHeaderBar',
    computed: {
        me() {
            return this.$store.getters.me
        },
        badges() {
            return this.$store.getters.badges || {}
        },
        photo_url() {
            if (!this.me) return ''
            if (!this.me.photos.length) return ''

            return this.me.photos[0].url
        },
        showUnreadNotifications() {
            return (this.$store.getters.notifications || []).filter(n => !n.read).length > 0
        },
    },
    data: () => ({
        headerTitle: '',
    }),
    methods: {
        onClickNotification() {
            this.$router.push({ name: 'NotificationsPage' })
        },
        async onClickHowToUsePoint() {
            const idx = await this.$modal.custom({
                component: 'ModalHowToUsePoint',
                options: {},
            })

            if (idx) this.$router.push({ name: 'InvitationFriendPage' })
        },

        clickToChatroom() {
            this.$router.push({ name: 'ChatroomPage' }).catch(e => {})
        }
    },
    mounted() {
        this.$bus.$on('setRootHeader', headerTitle => {
            this.headerTitle = headerTitle
        })
    },
    beforeDestroy() {
        this.$bus.$off('setRootHeader')
    },
}
</script>

<style lang="scss" scoped>
.root-header-bar {
    position: relative;
    width: 100vw;
    height: 60px;
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FAF0E1;
    .front-bi {
        justify-content: center;
    }

    .nav-title {
        justify-content: center;
        font-size: 17px;
        font-weight: 600;
    }

    .left {
        position: absolute;
        left: 20px;
        font-weight: 400;
        font-size: 18px;
        line-height: 28px;
        padding-top: 12px;
        color: #111111;
    }
    .right {
        display: flex;
        position: absolute;
        right: 20px;
        align-items: center;

        .privacy {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            @include center;
            background-color: $grey-02;
            margin-right: 20px;

            &.active {
                background-color: $blue-facebook;
            }
        }

        .material-icons {
            color: $grey-08;
        }

        .invitation-point {
            font-size: 16px;
            color: #111111;
            @include f-regular;
            margin-right: 8px;
        }

        .bell {
            height: 24px;
            flex: none;
        }
    }
}
</style>
